import { useContext, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import "./../../../assets/css/embla.css";
import { PrevButton, NextButton, usePrevNextButtons } from "./subComponents/entitiesCarouselArrowButton";
import Skeleton from "../skeletons/Skeleton";
import LayoutContext from "../../../contexts/LayoutContext";

export default function EntitiesCarousel({ entities = [], onEntityClick, isLoading = false }) {
    /* #region VARS */
    const OPTIONS = { align: "start" };
    const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

    const { isMobile } = useContext(LayoutContext);
    /* #endregion VARS */

    return (
        <>
            {isLoading ? (
                <div className="brands-container" style={{ display: "flex", gap: "5px" }}>
                    {[...Array(4)].map((_, i) => (
                        <Skeleton width={isMobile ? 195 : 460} height={isMobile ? 134 : 274} style={{ borderRadius: "0px" }} />
                    ))}
                </div>
            ) : (
                <div className="embla">
                    <div className="embla__viewport" ref={emblaRef}>
                        <div className="embla__container">
                            {entities?.map((value, index) => {
                                return (
                                    <div
                                        className="embla__slide__main"
                                        key={index}
                                        onMouseOver={() => setHoveredIndex(index)}
                                        onMouseOut={() => setHoveredIndex(null)}
                                        style={{
                                            cursor: value.isDisabled ? "not-allowed" : "pointer"
                                        }}
                                        onClick={() => {
                                            if (value?.isDisabled) return;
                                            if (onEntityClick) onEntityClick(value);
                                        }}>
                                        <div
                                            className="embla__slide"
                                            style={{
                                                backgroundImage: `url(${value?.backgroundLogo})`,
                                                opacity: hoveredIndex === index ? 1 : 0.3, // Change opacity on hover
                                                filter: hoveredIndex === index ? "blur(0px)" : "blur(4px)"
                                            }}></div>
                                        <div className="embla__slide__inner">
                                            <img className="embla__slide__number" src={value?.entityLogo} alt="" />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="embla__controls-arrow">
                        <div className="embla__buttons">
                            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
                            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
